import { render } from "./IconTextUp.vue?vue&type=template&id=ca90e412"
import script from "./IconTextUp.vue?vue&type=script&lang=js"
export * from "./IconTextUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__